<template>
  <section>
    <m-art-edit :form.sync="form" :form-rules="rules" :submit-func="submitFunc" :reset-form-callback="resetFormCallback"
                label-width="170px" ref="ad">
      <template v-slot:form-items>
        <m-card title="基本信息">
          <el-form-item label="广告名称" prop="name">
            <el-input v-model="ad.name" placeholder="" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="广告名称" prop="name">
            <el-select v-model="value" filterable placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择标签(可不选取)" prop="ProductsDiv">
            <m-transfer v-model="List"/>
          </el-form-item>
          <el-form-item label="广告封面图" prop="coverUrl">
            <div class="upload" v-loading="coverUploading">
              <input type="file" ref="upload" id="upload" accept="image/*" @change="upload"/>
              <div class="upload-preview" @click="selectFile">
                <div v-if="ad.coverUrl" class="remove" @click.stop="removeCover">
                  <i class="el-icon-close"></i>
                </div>
                <img v-if="ad.coverUrl" :src="ad.coverUrl" alt="">
                <div v-else class="upload-text">
                  <p>1、封面图建议尺寸690 * 220 px</p>
                  <p>2、图片大小不能超过10MB，将按图片宽度等比缩放</p>
                  <p>3、封面图为必填项</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="正文" prop="name">
            <div class="editor">
              <div class="ql-container ql-snow ql-editor editor-main">
                <quill-editor v-loading="coverUploading" :content="contents" @change="onEditorChange($event)"
                              ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)"
                              @focus="onEditorFocus($event)" @ready="onEditorReady($event)">
                </quill-editor>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="关联内容" prop="contentId">
            <el-select v-model="ad.contentId" placeholder="请选择" filterable remote :remote-method="remoteSearch"
                       :loading="remoteLoading" clearable>
              <el-option v-for="(item,index) in articleList" :key="index" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告分类" prop="advertisementType">
            <el-select v-model="ad.advertisementType" placeholder="请选择">
              <el-option v-for="item in categoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告排序" prop="sort">
            <el-input v-model.number="ad.sort" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="热区图片" prop="sort">
            <!-- <m-hotArea @getHotData="getInsideImg" :defaultImg="[adimg]" :itemData="imgData"></m-hotArea> -->
          </el-form-item>
          <!-- <el-form-item label="" v-if="edit">
  <el-button round type="primary" v-if="ad.status===2" :loading="waiting" @click="updateAd('ad',2)">保存</el-button>
  <el-button round type="primary" :loading="waiting" @click="updateAd('ad',1)">保存并发布</el-button>
</el-form-item>
<el-form-item label="" v-else>
  <el-button round type="primary" :loading="waiting" @click="saveAd('ad',2)">保存</el-button>
  <el-button round type="primary" :loading="waiting" @click="saveAd('ad',1)">保存并发布</el-button>
</el-form-item> -->
          <!--                    </el-form>-->
        </m-card>
      </template>
    </m-art-edit>
  </section>
</template>

<script>
/**
 * @method getCategories 获取内容分类
 * @method getArticleList 获取内容列表
 * @method getAd 获取广告详情
 * @method upload 上传
 * @method saveAd/updateAd 保存更新
 */
import api from "plus/api";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {quillEditor, Quill} from "vue-quill-editor";
import VideoBlot from "plus/plugins";

//Quill.register(VideoBlot);
import card from "components/card";
import transfer from "components/transfer";
// import hotArea from "components/hotArea/hotArea";

export default {
  components: {
    quillEditor,
    "m-card": card,
    "m-transfer": transfer,
    // 'm-hotArea': hotArea
    // 'm-hot': hotImg
  },
  data() {
    return {
      imgData: {},
      adimg: "",
      hotAreas: [],
      List: ["新春佳节即将来临，一起来展现自己的年味吧！"],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      contents: "",
      loading: false,
      waiting: false,
      edit: false,
      coverUploading: false,
      remoteLoading: false,
      articleList: [],
      categoryOptions: [],
      ad: {
        name: "",
        coverUrl: "",
        contentId: "",
        advertisementType: "",
        sort: "",
      },
      form: {},
      rules: {
        name: [
          {
            type: "string",
            required: true,
            message: "广告名称不能为空",
            trigger: "blur",
          },
        ],
        coverUrl: [
          {
            type: "string",
            required: true,
            message: "封面图不能为空",
            trigger: "change",
          },
        ],
        contentId: [
          {
            type: "string",
            required: true,
            message: "请选择关联内容",
            trigger: "change",
          },
        ],
        advertisementType: [
          {
            type: "number",
            required: true,
            message: "广告分类不能为空",
            trigger: "change",
          },
        ],
        sort: [
          {
            type: "number",
            required: true,
            message: "排序不能为空",
            trigger: "blur",
          },
        ],
      },
      editorOption: {
        placeholder: "请输入正文内容，不超过20000字",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["code-block"],
            [{header: 1}, {header: 2}],
            [{script: "sub"}, {script: "super"}],
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            [{color: []}, {background: []}],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
    };
  },
  async activated() {
    await this.getArticleList("");
    await this.getCategories();
    this.ad = this.$options.data().ad;
    // this.$refs['ad'].resetFields()
    if (this.$route.query.edit) {
      this.edit = true;
      this.loading = true;
      await this.getAd();
    } else {
      this.edit = false;
    }
  },
  deactivated() {
    this.clearUploadStatus();
  },
  methods: {
    getInsideImg(data) {
      this.adimg = data;
    },
    //以下为编辑器相关事件
    onEditorBlur(quill) {
      // ;
      // this.$refs['ad'].validateField('text')
    },
    onEditorFocus(quill) {
      // ;
    },
    onEditorReady(quill) {
      // ;
    },
    onEditorChange({quill, html, text}) {
      // ;
      const textLimit = 20000;
      if (text.length <= textLimit) {
        this.contents = html;
      } else {
        const range = quill.getLength();
        quill.deleteText(textLimit, range);
      }
    },
    submitFunc() {
      // TODO
    },
    resetFormCallback() {
      // TODO
    },
    async getAd() {
      try {
        let params = {
          id: this.$route.query.id,
        };
        const response = await api.cms.getAd(params);
        if (response.data.success) {
          this.ad = response.data.data;
          this.loading = false;
        } else {
          this.$message.error(response.data.msg);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.$message.error(error.message || error.msg);
      }
    },
    async getCategories() {
      try {
        const response = await api.cms.getAdCategory();
        if (response.data.success) {
          this.categoryOptions = response.data.data;
        } else {
          this.$message.error(response.data.msg);
        }
      } catch (error) {
        this.$message.error(error.message || error.msg);
      }
    },
    remoteSearch(query) {
      this.remoteLoading = true;
      this.getArticleList(query);
    },
    async getArticleList(title) {
      try {
        let params = {
          title: title,
          page: 1,
          size: 10,
          contentStatus: 1,
        };
        const response = await api.cms.getContentList(params);
        if (response.data.success) {
          this.articleList = response.data.data.items;
          this.remoteLoading = false;
        } else {
          this.remoteLoading = false;
          this.$message.error(response.data.msg);
        }
      } catch (error) {
        this.remoteLoading = false;
        this.$message.error(error.message || error.msg);
      }
    },
    async saveAd(formName, type) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let params = Object.assign({}, this.ad);
            params.status = type;
            this.waiting = true;
            const response = await api.cms.createAd(params);
            if (response.data.success) {
              this.$message.hint("保存成功");
              this.$refs[formName].resetFields();
              this.waiting = false;
            } else {
              this.waiting = false;
              this.$message.error(response.data.msg);
            }
          } catch (error) {
            this.waiting = false;
            this.$message.error(error.message || error.msg);
          }
        } else {
          return false;
        }
      });
    },
    async updateAd(formName, type) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let params = Object.assign({}, this.ad);
            params.status = type;
            this.waiting = true;
            const response = await api.cms.updateAd(params);
            if (response.data.success) {
              this.$message.hint("修改成功");
              this.waiting = false;
            } else {
              this.waiting = false;
              this.$message.error(response.data.msg);
            }
          } catch (error) {
            this.waiting = false;
            this.$message.error(error.message || error.msg);
          }
        } else {
          return false;
        }
      });
    },
    selectFile() {
      this.$refs["upload"].click();
    },
    removeCover() {
      this.ad.coverUrl = "";
    },
    upload(files) {
      const file = files.target.files[0];
      let self = this;
      this.coverUploading = true;
      if (file) {
        const size = file.size / 1024 / 1024 < 10;
        if (size) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function () {
            var blob = reader.result;
            let data = {};
            try {
              const result = await api.qiniu.getToken();
              let data = result.data.data;
              let token = data.token;

              let FileName = data.fileName;
              let index = file.name.lastIndexOf(".");
              let name = file.name.substr(index);
              FileName += name;
              let formdata = new FormData();
              formdata.append("imagefile", blob);
              formdata.append("token", token);
              formdata.append("file", file);
              formdata.append("key", FileName);
              const uploadResult = await api.qiniu.upload(
                  formdata
              );
              self.ad.coverUrl =
                  "https://cdn-workorder.meb.com/" + uploadResult.data.key;
              self.coverUploading = false;
              self.$refs["ad"].validateField("coverUrl");
              self.clearUploadStatus();
            } catch (error) {
              self.clearUploadStatus();
              self.$message.error(
                  error.msg ||
                  error.message ||
                  error.response.data.error
              );
            }
          };
        } else {
          this.$message.error("上传文件过大");
        }
      }
    },
    clearUploadStatus() {
      this.$refs["upload"].value = "";
    },
  },
};
</script>
<style lang="less" scoped>
.upload {
  position: relative;
  display: flex;
  cursor: pointer;

  .upload-preview {
    width: 100%;
    height: 100%;
    border: 1px dashed #999999;
    display: flex;
    justify-content: center;
    align-items: center;

    & > img {
      width: 300px;
      object-fit: contain;
    }

    .remove {
      position: absolute;
      right: -15px;
      top: -15px;
      font-size: 24px;
      border: 1px solid;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: #000000;
      color: #ffffff;
      cursor: pointer;
    }

    .upload-text {
      color: #999999;
    }
  }
}

#upload {
  display: none;
}

.editor {
  position: relative;
  height: 500px;
}

.quill-editor {
  position: relative;
  height: 400px;
}

.ql-editor.editor-main {
  border: none;
  padding: 0;
}
</style>
